
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist/[pid]/tour",
      function () {
        return require("private-next-pages/artist/[pid]/tour.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist/[pid]/tour"])
      });
    }
  